var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLockAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58886 0 0 3.58886 0 8C0 12.4111 3.58886 16 8 16C12.4111 16 16 12.4111 16 8C16 3.58886 12.4111 0 8 0ZM1.99998 8C1.99998 6.70617 2.41575 5.50995 3.11487 4.52892L11.471 12.8851C10.49 13.5842 9.2938 14 7.99997 14C4.69142 14 1.99998 11.3086 1.99998 8ZM12.8851 11.4711L4.52889 3.11487C5.50992 2.41578 6.70614 1.99998 7.99997 1.99998C11.3086 1.99998 14 4.69139 14 7.99997C14 9.29383 13.5842 10.49 12.8851 11.4711Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockAccount);
export default __webpack_public_path__ + "static/media/IconLockAccount.2705c1e55f9a74acda37c9206b7c90e0.svg";
export { ForwardRef as ReactComponent };